import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'field-of-activity';

    fields = [];

    getFields() {
        if (!this.fields.length) {
            return this.get({
                params: {
                    'response-group': 'default',
                },
            })
                .then(r => r.data)
                .then(fields => {
                    this.fields = fields;
                    return this.fields;
                })
                .catch(err => {
                    //@todo: show an error?
                    // this.error = err.message;
                    return [];
                });
        } else {
            return Promise.resolve(this.fields);
        }
    }
}

export const FieldOfActivityModel = new model();
